export type BrokerNerdsBarkerCoreEnumsShowEventCountdown = (typeof BrokerNerdsBarkerCoreEnumsShowEventCountdown)[keyof typeof BrokerNerdsBarkerCoreEnumsShowEventCountdown];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsShowEventCountdown = {
  Never: 'Never',
  Always: 'Always',
  OnlyWithin24Hours: 'OnlyWithin24Hours',
  OnlyWithin48Hours: 'OnlyWithin48Hours',
} as const;
